import { render, staticRenderFns } from "./SaasIcon.vue?vue&type=template&id=0f9668f0&"
import script from "./SaasIcon.vue?vue&type=script&lang=js&"
export * from "./SaasIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports